


import useBaseApiHook, { BASE_API_CONSTANT } from "services/useBaseApiHook"

const REPO_URL = {
    getList: '/dept/paginated',
    getById: '/dept/id',
    create: '/dept/save',
    update: '/dept/update',
    delete: '/dept/delete'  
}

const useDepartmentRepo = (initialLoading = false) => {
    const { isLoading, data, error, executeApi } = useBaseApiHook(initialLoading)

    const getDepartmentList = async (payload) => {
        return await executeApi(REPO_URL.getList, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const getDepartmentById = async (payload) => {
        return await executeApi(REPO_URL.getById, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const createDepartment = async (payload) => {
        return await executeApi(REPO_URL.create, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const updateDepartment = async (payload) => {
        return await executeApi(REPO_URL.update, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    
    const deleteDepartment = async (payload) => {
        return await executeApi(REPO_URL.delete, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    return {
        isLoading,
        data,
        error,
        getDepartmentList,
        getDepartmentById,
        createDepartment,
        updateDepartment,
        deleteDepartment
    }
}

export default useDepartmentRepo
